import { useCallback, useEffect, useState } from 'react'
import AdditionalSalesThemeSplashScreen from '../../components/AdditionalSales/AdditionalSalesThemeSplashScreen'
import { getPictoByThemeId } from '../../utils/pictos'
import { setPageTitle } from '../../utils/pageTitle'
import '../../components/AdditionalSales/AdditionalSalesView.css'

const MISSION_THEME_IDS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
const COCKTAIL_THEME_ID = 13

const EluceoThemeButton = ({ themeId, onClick }) => {
  const Picto = getPictoByThemeId(themeId)

  return (
    <button className="themeGroup" type="button" onClick={() => onClick(themeId)}>
      <Picto className="picto" />
    </button>
  )
}

const Eluceo = () => {
  const [selectedThemeId, setSelectedThemeId] = useState(null)

  useEffect(() => {
    setPageTitle('Eluceo')
    document.body.classList.add('additionalSalesBody')

    return () => {
      document.body.classList.remove('additionalSalesBody')
    }
  }, [])

  const openTheme = useCallback((themeId) => {
    setSelectedThemeId(themeId)
  }, [])

  const closeTheme = useCallback(() => {
    setSelectedThemeId(null)
  }, [])

  return (
    <div className="additionalSalesRoot eluceoRoot">
      <div className="additionalSalesHome hero">
        <div id="header">
          <h3>Psssst</h3>
          <h1>
            Découvre
            <br />
            nos 12 missions
          </h1>
        </div>
        <div className="themeButtonsWrapper">
          {MISSION_THEME_IDS.map((themeId) => (
            <EluceoThemeButton key={themeId} themeId={themeId} onClick={openTheme} />
          ))}
          <div className="eluceoSeparator" />
          <EluceoThemeButton themeId={COCKTAIL_THEME_ID} onClick={openTheme} />
        </div>
      </div>

      <AdditionalSalesThemeSplashScreen themeId={selectedThemeId} onClose={closeTheme} />
    </div>
  )
}

export default Eluceo
